import {Component, Input, OnInit} from '@angular/core';

export interface TractorsEnginePowerPerHectare {
  domainID: number;
  domainName: string;
  mp: number;
  gp: number;
}

@Component({
  selector: 'app-tractors-engine-power-per-hectare-widget',
  templateUrl: './tractors-engine-power-per-hectare-widget.component.html',
  styleUrls: ['./tractors-engine-power-per-hectare-widget.component.scss']
})
export class TractorsEnginePowerPerHectareWidgetComponent implements OnInit {

  @Input()
  data: TractorsEnginePowerPerHectare[];

  constructor() {
  }

  ngOnInit(): void {
  }

}
